import {DoorType} from "../models/door";
import {DoorType as DoorTypeGQL} from "../../generated/graphql";
import {assertNever} from "./utils";

export function mapDoorTypeFromInternToGraphQl(internalDoorType?: DoorType): DoorTypeGQL | undefined {
  if (!internalDoorType) return undefined

  switch (internalDoorType) {
    case DoorType.DOUBLE:
      return DoorTypeGQL.Double;
    case DoorType.SINGLE:
      return DoorTypeGQL.Single;
    case DoorType.ENTRY:
      return DoorTypeGQL.Entry;
    case DoorType.GARAGE:
      return DoorTypeGQL.Garage;
    case DoorType.PATIO:
      return DoorTypeGQL.Patio;
    case DoorType.INTERIOR:
      return DoorTypeGQL.Interior;
    case DoorType.INTERIOR_DOUBLE:
      return DoorTypeGQL.InteriorDouble;
    case DoorType.GLIDING:
      return DoorTypeGQL.Gliding;
    case DoorType.FLOOR:
      return DoorTypeGQL.Floor;
    case DoorType.GARAGE_DOUBLE:
      return DoorTypeGQL.GarageDouble;
    case DoorType.FRONT:
      return DoorTypeGQL.Front;
    case DoorType.EXTERIOR:
      return DoorTypeGQL.Exterior;
    case DoorType.EXTERIOR_DOUBLE:
      return DoorTypeGQL.ExteriorDouble;
    default:
      return assertNever(internalDoorType);
  }
}

export function mapDoorTypeFromGraphQlToIntern(doorType?: DoorTypeGQL | null): DoorType | undefined {
  if (!doorType) return undefined

  switch (doorType) {
    case DoorTypeGQL.Double:
      return DoorType.DOUBLE;
    case DoorTypeGQL.Single:
      return DoorType.SINGLE;
    case DoorTypeGQL.Entry:
      return DoorType.ENTRY;
    case DoorTypeGQL.Garage:
      return DoorType.GARAGE;
    case DoorTypeGQL.Patio:
      return DoorType.PATIO;
    case DoorTypeGQL.Interior:
      return DoorType.INTERIOR;
    case DoorTypeGQL.InteriorDouble:
      return DoorType.INTERIOR_DOUBLE;
    case DoorTypeGQL.Gliding:
      return DoorType.GLIDING;
    case DoorTypeGQL.GarageDouble:
      return DoorType.GARAGE_DOUBLE;
    case DoorTypeGQL.Floor:
      return DoorType.FLOOR;
    case DoorTypeGQL.Front:
      return DoorType.FRONT;
    case DoorTypeGQL.Exterior:
      return DoorType.EXTERIOR;
    case DoorTypeGQL.ExteriorDouble:
      return DoorType.EXTERIOR_DOUBLE;
    default:
      return assertNever(doorType);
  }
}
